export enum FEATURES {
  cc = 'cc',
  indicators = 'indicators',
  language = 'language',
}

const INDICATORS_FEATURE = 'showIndicators';
const CAPTIONS_FEATURE = 'showCaptions';
const LANGUAGE_FEATURE = 'showLanguage';

const checkFeature = (value: string): value is keyof typeof FEATURES => {
  return Object.keys(FEATURES).includes(value);
};

export const appFeature = (value: keyof typeof FEATURES) => {
  if (!checkFeature(value)) {
    console.warn(`You entered a wrong feature value: "${value}". Try one of: ${Object.keys(FEATURES).join(', ')}`);
    return;
  }

  switch (value) {
    case 'indicators': {
      localStorage.setItem(INDICATORS_FEATURE, 'true');
      break;
    }
    case 'cc': {
      localStorage.setItem(CAPTIONS_FEATURE, 'true');
      break;
    }
    case 'language': {
      localStorage.setItem(LANGUAGE_FEATURE, 'true');
      break;
    }
  }
};

export const isIndicatorFeature = () => localStorage.getItem(INDICATORS_FEATURE) === 'true';

export const isCaptionsFeature = () => localStorage.getItem(CAPTIONS_FEATURE) === 'true';
export const isLanguageFeature = () => localStorage.getItem(LANGUAGE_FEATURE) === 'true';
